import type { Prisma } from "@prisma/client";

/**
 * Email columns stored lowercased and trimmed, by Prisma model. The extension
 * normalizes these in written data and in `where` filters, so a write can't
 * store "Jane@x.com" and an exact lookup can't miss it. `User`,
 * `Participant` and `EventRecordingAccess` also have a CHECK constraint
 * enforcing it.
 */
export const NORMALIZED_EMAIL_FIELDS: Partial<
  Record<Prisma.ModelName, readonly string[]>
> = {
  User: ["email"],
  Participant: ["email"],
  EventRecordingAccess: ["email"],
  StakeholderConversation: ["hostEmail"],
};

/** Filter operators whose operands are whole addresses, not search text. */
export const NORMALIZED_FILTER_OPERATORS = [
  "equals",
  "in",
  "notIn",
  "not",
] as const;
